import { Link, useLocation, useNavigate } from 'react-router-dom';
import routes from 'store/configs/Routes';
import ComponentProps from 'store/types/ComponentProps';
import { LOGIN_REDIRECT, setLocalStorageValue } from 'util/localStorage';

const SignInLink: React.FunctionComponent<ComponentProps> = ({ children, className = '' }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setLocalStorageValue(LOGIN_REDIRECT, location.pathname);
    navigate(routes.login);
  };

  return (
    <Link className={className} to={routes.login} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default SignInLink;
